import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  Stack,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

const ServiceVendorFormModal = ({ toggle, onClose, formik }: any) => {
  const { handleSubmit, values, handleChange, errors, touched, isSubmitting } =
    formik;
  return (
    <Dialog open={toggle} onClose={onClose} fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{values.id ? 'Edit vendor' : 'New vendor'}</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2} sx={{ pt: 1 }}>
            <TextField
              fullWidth
              label='Name'
              name='name'
              value={values.name}
              onChange={handleChange}
              error={Boolean(errors.name && touched.name)}
              helperText={Boolean(errors.name && touched.name) && errors.name}
            />
            <TextField
              fullWidth
              label='Email'
              name='email'
              value={values.email}
              onChange={handleChange}
            />
            <TextField
              fullWidth
              label='Phone number 1'
              name='extraMobile1'
              value={values.extraMobile1}
              onChange={handleChange}
              error={Boolean(errors.extraMobile1 && touched.extraMobile1)}
              helperText={
                Boolean(errors.extraMobile1 && touched.extraMobile1) &&
                errors.extraMobile1
              }
            />
            <TextField
              fullWidth
              label='Phone number 2'
              name='extraMobile2'
              value={values.extraMobile2}
              onChange={handleChange}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.isActive}
                  onChange={(e) =>
                    formik.setFieldValue('isActive', e.target.checked)
                  }
                />
              }
              label='Active Status'
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <LoadingButton type='submit' variant='contained' loading={isSubmitting}>
            Save
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ServiceVendorFormModal;
